<script>
export default {
  name: "DikeTrajectoryGenerateMixin",
  data: () => ({
    distance: 100,
  }),
  methods: {
    async generateFromDistance() {
      this.uploading = true
      try {
        await this.generate({properties: {distance: this.distance}})
      } catch (e) {
        console.log(e)
        this.uploading = false
      }
      this.uploading = false
    },
  }
}
</script>

